<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="基础信息" >
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="厂区" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="factoryId">
              <a-select  placeholder="请选择厂区" v-model="model.factoryId"  @change="backFactory"  >
                <a-select-option
                  v-for="d in factoryOptions"
                  :key="d.id"
                  :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="区域" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaId">
              <a-select  placeholder="请选择区域" v-model="model.areaId"  @change="backArea" >
                <a-select-option
                  v-for="d in areaOptions"
                  :key="d.id"
                  :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="楼栋编码" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="code">
              <a-input v-model="model.code" placeholder="请输入楼栋编码"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="楼栋名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <a-input v-model="model.name" placeholder="请输入楼栋名称"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="楼栋负责人信息" >
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="负责人姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="principal">
              <a-input v-model="model.principal" placeholder="请输入负责人姓名"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="联系电话" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="telephone">
              <a-input v-model="model.telephone" placeholder="请输入负责人联系电话"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="email">
              <a-input v-model="model.email" placeholder="请输入负责人邮箱"  ></a-input>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
               <j-switch v-model="model.status" ></j-switch>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="24">
            <a-form-model-item label="楼栋图片信息">
            </a-form-model-item>
          </a-col>      
          <a-col :span="24">
            <a-form-model-item label="">
              <j-image-upload class="avatar-uploader" text="上传" :upload-source="uploadSource" v-model="model.fileList" :isMultiple="true" :disabled="disableSubmit"></j-image-upload>
            </a-form-model-item>
          </a-col>      
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { disabledAuthFilter } from "@/utils/authFilter"
  import { FormTypes,getRefPromise,VALIDATE_NO_PASSED,validateFormModelAndTables } from '@/utils/JEditableTableUtil'

  export default {
    name: 'PreBuildingForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
          status:'Y'
         },
        disableSubmit:false,
        factoryOptions:[],
        areaOptions:[],
        uploadSource:'prevent',
        fileList:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 12 },
          sm: { span: 5 },
        },
        wrapperCol2: {
          xs: { span: 36 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          list: "/prevent/factory/prefactorys",
          listAreas: "/prevent/area/preareas",
          add: "/prevent/building/prebuildingAdd",
          edit: "/prevent/building/prebuildingEdit",
          queryByMainId: "/prevent/PreFile/prefileQueryByMainId"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      validatorRules(){
        return {
         factoryId: [
            { required: true, message: '请输入厂区!'},
         ],
         areaId: [
            { required: true, message: '请输入区域!'},
         ],
         code: [
            { required: true, message: '请输入楼栋编码!'},
         ],
         name: [
            { required: true, message: '请输入楼栋名称!'},
         ],
         principal: [
            { required: true, message: '请输入负责人姓名!'},
         ],
         telephone: [
            { required: true, message: '请输入负责人联系电话!'},
            {validator: this.validatePhone},
         ],
         email: [
            { required: true, message: '请输入负责人邮箱!'},
            {validator: this.validateEmail},
         ],
         status: [
            { required: true, message: '请输入是否启用!'},
         ],
      }
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.loadData();
    },
    methods: {
      loadData(){
        this.loading = true
        let params = {pageNo:1,pageSize:100000};
        getAction(this.url.list,params).then(res=>{
          if(res.success){
            let result = res.result
            if(Number(result.total)>0){                                       
              this.factoryOptions = result.records.map(item=>{
                  let c ={id:item.id, name: item.name}
                  return c;
              });              
            }
          }else{
            this.$message.warning(res.message)
          }
        });
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        let params = {factoryId:this.model.factoryId, pageNo:1,pageSize:100000};
        
          getAction(this.url.listAreas,params).then(res=>{
            if(res.success){
              let result = res.result
              if(Number(result.total)>0){                                       
                this.areaOptions = result.records.map(item=>{
                    let c ={id:item.id, name: item.name}
                    return c;
                });              
              }
            }
          });
        
        let paraFile = {mainId:this.model.id,fileType:'building'};
        console.log('---paraFile---' + paraFile);
        getAction(this.url.queryByMainId,paraFile).then(res=>{
          console.log('--file---' + res.success);
          if(res.success){
            let result = res.result
            console.log('--result----' + result);
            this.model.fileList = res.result;
          }
        })
        
      },
      backFactory(val){
        this.$set(this.$data, 'model', {
          ...this.model,
          areaId: ''
        });
        this.areaOptions  = [];
        let params = {factoryId:this.model.factoryId, pageNo:1,pageSize:100000};
        getAction(this.url.listAreas,params).then(res=>{
          if(res.success){
            let result = res.result
            if(Number(result.total)>0){                                       
              this.areaOptions = result.records.map(item=>{
                  let c ={id:item.id, name: item.name}
                  return c;
              });              
            }
          }else{
            this.$message.warning(res.message);
          }
        })
      },
      backArea(val)
      {
        /* this.model.areaId = val.toString();
        this.$forceUpdate(); */
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            console.log('--fileList--' + this.model.fileList);
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                this.$message.success(res.message);
                this.$emit('ok');
              }else{
                this.$message.warning(res.message);
              }
            }).finally(() => {
              this.confirmLoading = false;
            })
          }

        })
      },
      validatePhone(rule, value, callback){
        if(!value){
          callback();
        }else{
          if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)){
            callback();
          }else{
            callback("请输入正确格式的手机号码!");
          }
        }
      },
      validateEmail(rule, value, callback){
        if(!value){
          callback();
        }else{
          if(new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)){
            callback();
          }else{
            callback("请输入正确格式的邮箱!");
          }
        }
      },
    }
  }
</script>
